import script from "./BVIworkplace.vue?vue&type=script&setup=true&lang=js"
export * from "./BVIworkplace.vue?vue&type=script&setup=true&lang=js"

import "./BVIworkplace.vue?vue&type=style&index=0&id=07134696&scoped=true&lang=scss"

import exportComponent from "D:\\Projects\\profgame\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07134696"]])

export default __exports__